import { render, staticRenderFns } from "./photoQtdSelect.vue?vue&type=template&id=516586da&scoped=true"
import script from "./photoQtdSelect.vue?vue&type=script&lang=js"
export * from "./photoQtdSelect.vue?vue&type=script&lang=js"
import style0 from "./photoQtdSelect.vue?vue&type=style&index=0&id=516586da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516586da",
  null
  
)

export default component.exports